<template>
  <el-container class="commodity-management-list">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList="searchList" :searchEnd='searchEnd' :rightEventList="rightEventList"
        v-on:getSearchObj="getSearchObj" @rightFunc='rightFunc'>
      </publicExpandSearch>
    </div>
    <el-main class="commodity-content">
      <el-table :data="commodityData" style="width: 100%"
        :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}">
        <el-table-column type="index" label="序号" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="goodsDesc" label="商品说明" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="商品零售价" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.specCurrentPrice|money }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operateUser" label="操作人" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.goodsState === 1" class="payment-state" style="background: #D6F1FF">已下架</span>
            <span v-if="scope.row.goodsState === 2" class="payment-state" style="background: #FFECDB">上架中</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-popconfirm title="当前商品正在被使用，详情请查看引用列表" confirm-button-text='继续下架' cancel-button-text='取消下架'
              @cancel="downShelvesCancel" @confirm="downShelves(scope.row)">
              <el-button slot="reference" type="text" size="small" @click="downShelvesF">下架商品</el-button>
            </el-popconfirm> -->
            <el-button type="text" size="small" v-if="scope.row.goodsState !== 1"
              @click="downShelvesF(scope.row)">下架商品</el-button>
            <el-button type="text" size="small" v-if="scope.row.goodsState === 1"
              @click="upShelves(scope.row)">上架商品</el-button>
            <el-button type="text" size="small" :disabled="scope.row.goodsState !== 1"
              @click="editGoods(scope.row)">编辑</el-button>
            <!-- 已下架的直接移除，未下架的弹框提示 -->
            <el-popconfirm title="确认移除吗？" confirm-button-text='确认' cancel-button-text='取消'
              @confirm="deleteGoods(scope.row)">
              <el-button slot="reference" type="text" size="small" :disabled="scope.row.goodsState === 2">移除商品</el-button>
            </el-popconfirm>
            <!-- <el-button type="text" size="small">统计</el-button> -->
            <el-button type="text" size="small" @click="referenceListClick(scope.row)">引用列表</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 50]"
          :current-page.sync="searchParams.current" :page-size="searchParams.size"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-main>
    <!-- 引用列表 -->
    <el-drawer :visible.sync="drawerReference" :direction="direction" :before-close="handleClose"
      class="reference-drawer">
      <h3>引用列表</h3>
      <span>当前商品在以下落地页有使用：</span>
      <el-table :data="landingPageData" style="width: 100%"
        :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}">
        <el-table-column prop="name" label="落地页名称" align="center">
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 30px">
        <el-pagination @size-change="sizeChangeLand" @current-change="currentChangeLand" :page-sizes="[10, 20, 30, 50]"
          :current-page.sync="landingPage.current" :page-size="landingPage.size"
          layout="total, sizes, prev, pager, next, jumper" :total="landingPage.total" style="display: flex">
        </el-pagination>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import local from "@/utils/local.js";
import {
  goodsPage,
  goodsShelves,
  goodsDelete,
  goodsUseState,
  goodsLandingPage
} from "../../api/index";
export default {
  data() {
    return {
      breadList: [{ name: "商品管理" }, { name: "商品管理" }],
      rightEventList: [{ eventName: "新增商品", eventValue: 1 }],
      searchList: [
        {
          label: "商品名称",
          paramName: "goodsName",
          inputType: "input"
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      searchEnd: {},
      total: 0,
      commodityData: [],
      tableConfig: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          type: "index"
        },
        {
          label: "订单编号",
          align: "center",
          prop: "planName",
          size: "mini"
        },
        {
          label: "用户",
          align: "center",
          prop: "planDescribe",
          size: "mini"
        },
        {
          label: "商品分类",
          align: "center",
          prop: "updateTime1",
          size: "mini"
        },
        {
          label: "商品数量",
          align: "center",
          prop: "planDescribe1",
          size: "mini"
        },
        {
          label: "商品零售价",
          align: "center",
          prop: "updateTime2",
          size: "mini"
        },
        {
          label: "当前商品实付金额",
          align: "center",
          prop: "planDescribe2",
          size: "mini"
        },
        {
          label: "相关绑定",
          align: "center",
          prop: "updateTime3",
          size: "mini"
        },
        {
          label: "创建时间",
          align: "center",
          prop: "updateTime7",
          size: "mini"
        },
        {
          label: "支付方式",
          align: "center",
          prop: "updateUser",
          size: "mini"
        },
        {
          label: "商户订单号",
          align: "center",
          prop: "updateTime5",
          size: "mini"
        },
        {
          label: "支付时间",
          align: "center",
          prop: "planDescribe3",
          size: "mini"
        },
        {
          label: "退款人",
          align: "center",
          prop: "updateTime6",
          size: "mini"
        },
        {
          label: "退款金额",
          align: "center",
          prop: "planDescribe4",
          size: "mini"
        },
        {
          label: "退款备注",
          align: "center",
          prop: "updateTime",
          size: "mini"
        },
        {
          label: "退款时间",
          align: "center",
          prop: "updateTime8",
          size: "mini"
        },
        // '' info success danger info warning
        {
          label: "订单状态",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                <el-tag
                  type={scope.row.recordStatus === "家" ? "primary" : "success"}
                  disable-transitions
                >
                  {scope.row.recordStatus}
                </el-tag>
              </span>
            );
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.edit(scope.row);
                    }
                  }
                },
                "详情"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.changeStatus(scope.row);
                    }
                  }
                },
                "退款"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.changeStatus(scope.row);
                    }
                  }
                },
                "物流"
              )
            ]);
          }
        }
      ],
      drawerReference: false,
      landingPageData: [],
      landingPage: {
        current: 1,
        size: 10
      },
      direction: "rtl",
      useState: 0,
      downShelvesObj: {}
    };
  },
  created() {
    let { condition } = this.$route.params;
    if (
      condition &&
      (condition.goodsName || condition.current !== 1 || condition.size !== 10)
    ) {
      let end = this.$route.params.condition;
      this.searchEnd = end;
      this.searchParams = { ...this.searchParams, ...this.searchEnd };
    }
    this.getInitTableData();
  },
  mounted() {},
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getInitTableData();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push({
          path: "/CommodityManagement/CommodityManagementList/addCommodity"
        });
      }
    },
    downShelvesF(row) {
      // 调用接口判断是否需要二次弹框提示
      this.downShelvesObj = row;
      goodsUseState(row.goodsId).then(ress => {
        // 判断状态值为1时给出提示 为0时继续下架
        if (ress.code === 0) {
          if (ress.data.useState) {
            // this.useState = ress.data.useState;
            this.$confirm(
              `当前商品正在被使用，详情请查看引用列表`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(() => {
                this.downShelves(this.downShelvesObj)
              })
              .catch(() => {});
          } else {
            this.downShelves(row);
          }
        }
      });
    },
    async getInitTableData() {
      let { code, data } = await goodsPage(this.searchParams);
      if (code === 0) {
        // this.commodityData = [];
        this.commodityData = data.records.map(item => {
          let specCurrentPrice = "";
          item.goodsSpecVoList.forEach(items => {
            specCurrentPrice = items.specCurrentPrice;
          });
          // 商品使用状态查询
          // goodsUseState(item.goodsId).then(ress => {
          //   this.commodityData.push({
          //     ...item,
          //     specCurrentPrice,
          //     isUse: ress.data ? ress.data.useState : 0
          //   });
          // });
          return {
            ...item,
            specCurrentPrice
            // isUse: ress.data ? ress.data.useState : 0
          };
        });
        console.log("this.commodityData", this.commodityData);
        this.total = data.total;
      } else {
        this.commodityData = [];
      }
    },
    sizeChange(e) {
      this.searchParams.size = e;
      this.getInitTableData();
    },
    currentChange(e) {
      this.searchParams.current = e;
      this.getInitTableData();
    },
    handleClose() {
      this.drawerReference = false;
    },
    // 商品下架
    async downShelves(row) {
      let { code, data } = await goodsShelves({
        goodsId: row.goodsId,
        goodsState: row.goodsState === 1 ? 2 : 1
      });
      if (code === 0) {
        this.$message("下架成功");
        this.useState = 0;
        this.getInitTableData();
      }
    },
    // 取消商品下架
    downShelvesCancel() {},
    // 商品上架
    async upShelves(row) {
      let { code, data } = await goodsShelves({
        goodsId: row.goodsId,
        goodsState: row.goodsState === 1 ? 2 : 1
      });
      if (code === 0) {
        this.$message("上架成功");
        this.getInitTableData();
      }
    },
    deleteGoods(row) {
      goodsDelete(row.goodsId)
        .then(res => {
          if (res.code === 0) {
            this.$message("商品移除成功");
            this.getInitTableData();
          }
        })
        .catch(err => {
          if (err.code === 2001) {
            this.getInitTableData();
          }
        });
    },
    editGoods(row) {
      local.set("goodsListCon", JSON.stringify(this.searchParams));
      console.log("...this.searchParams", this.searchParams);
      this.$router.push({
        path: "/CommodityManagement/CommodityManagementList/addCommodity",
        query: { id: row.goodsId }
      });
    },
    // 商品引用列表
    async referenceListClick(row) {
      this.drawerReference = true;
      this.landingPage = { ...this.landingPage, ...row };
      let { code, data } = await goodsLandingPage({
        current: this.landingPage.current,
        size: this.landingPage.size,
        goodsId: row.goodsId
      });
      if (code === 0) {
        this.landingPageData = data.records;
        this.landingPage = {
          ...this.landingPage,
          total: data.total
        };
      }
    },
    sizeChangeLand(e) {
      this.landingPage.size = e;
      this.referenceListClick(this.landingPage);
    },
    currentChangeLand(e) {
      this.landingPage.current = e;
      this.referenceListClick(this.landingPage);
    }
  }
};
</script>

<style>
.el-popconfirm__main {
  margin: 10px 0;
}
</style>

<style lang="less" scoped>
.commodity-management-list {
  height: 100%;
  width: 100%;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;

  .commodity-content {
    padding: 16px;
    background: #fff;
    .el-table {
      .el-button {
        margin-right: 10px;
      }
    }
  }
  /deep/.reference-drawer {
    .el-drawer__body {
      text-align: center;
      padding: 0 40px;
      h3 {
        font-size: 22px;
        font-weight: bold;
        line-height: 3;
      }
      span {
        display: block;
        color: #333333;
        font-size: 14px;
        margin-bottom: 20px;
      }
    }
  }
  .payment-state {
    padding: 2px 6px;
    border-radius: 2px;
    background: #eeeeee;
  }
  // 是否移除气泡框
}
</style>